import React from 'react';
import { Label, Header, Checkbox } from 'semantic-ui-react';
import { pinRestrictedRatings, Slider } from '@emyw/core-lib';

// const style = { borderLeft: 'dotted grey 0.1em', marginLeft: '-0.05em', textAlign: 'center' };
// const lastTickStyle = { borderRight: 'dotted grey 0.1em', marginRight: '-0.05em' };
const rlbl = val => /*#__PURE__*/React.createElement(Label, {
  key: val,
  size: "tiny",
  style: {
    marginBottom: '0.5em'
  }
}, val);
const labels = {};
pinRestrictedRatings.filter(li => li.text).forEach((labelItem, i) => {
  labels[i] = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, labelItem.text), (labelItem.groupCodes || '').split('|').map(rating => rlbl(rating)));
});
export default class PinRestrictions extends React.Component {
  constructor() {
    super(...arguments);
    this.handleContentPINRestrictedUpdate = (e, value) => {
      this.props.onContentPINRestrictedUpdate(pinRestrictedRatings[value]);
    };
    this.handleFilterChangesNeedPINUpdate = (e, data) => {
      this.props.onFilterChangesNeedPINUpdate(data.checked);
    };
  }
  render() {
    const {
      contentPINRestricted,
      filterChangesNeedPIN,
      disabled
    } = this.props;
    // const { value } = this.state;
    let prrIndex = 0;
    let description = 'unknown setting';
    if (contentPINRestricted) {
      prrIndex = Math.min(4, pinRestrictedRatings.findIndex(pr => pr.code === contentPINRestricted));
      ({
        description
      } = pinRestrictedRatings[prrIndex] || {});
    }

    // if (!modalMode) {
    const dialogJsx = /*#__PURE__*/React.createElement("div", {
      className: "featureDialog"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dialogContent",
      style: {
        minWidth: 'unset'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "dialogTitle"
    }, /*#__PURE__*/React.createElement("div", null, "Restrict by Maturity Level"), disabled && /*#__PURE__*/React.createElement("div", {
      className: "dialogHeaderWarning"
    }, "* This feature requires an account level PIN")), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: '2em'
      },
      className: "pinRestriction"
    }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Header.Subheader, {
      style: {
        fontSize: '0.75em'
      }
    }, description)), /*#__PURE__*/React.createElement(Slider, {
      min: 0,
      max: Object.keys(labels).length,
      value: prrIndex,
      step: 1,
      labels: labels,
      ticks: true,
      reverse: true,
      centerLabels: true,
      disabled: disabled,
      onChange: this.handleContentPINRestrictedUpdate
    }), /*#__PURE__*/React.createElement(Header, {
      style: {
        borderTop: '1px solid rgba(34,36,38,.15)'
      }
    }, /*#__PURE__*/React.createElement(Header.Subheader, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, "Note:"), " If a show's content rating is unavailable it is considered", /*#__PURE__*/React.createElement(Label, {
      size: "tiny"
    }, "NR"))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
      toggle: true
      /* If filterChangesNeedPIN is undefined, Checkbox will think it's an uncontrolled input, so cast to Boolean: */,
      checked: Boolean(filterChangesNeedPIN),
      label: "Require PIN to change Filter Settings",
      onChange: this.handleFilterChangesNeedPINUpdate,
      disabled: disabled
    })))));
    // if (disabled) {
    //     return (
    //         <Popup
    //             className="enjoyPopup featureDialogPopup featureDescription"
    //             trigger={dialogJsx}
    //             wide
    //             position="left center"
    //             content={`Set an account level PIN to access content restriction features${'.'}`}
    //         />
    //     );
    // }

    return dialogJsx;

    // }
    // return (
    //     <Modal open={open} centered={false} size="small">
    //         <Modal.Header>
    //             PIN Required Content Ratings
    //             <Header as="h4" style={{ paddingTop: '0.5em', color: 'grey' }}>
    //                 {description}
    //             </Header>
    //         </Modal.Header>
    //         <Modal.Content>
    //             <Slider
    //                 style={{ fontSize: '14px'/* , height: '100%' */ }}
    //                 min={0}
    //                 max={Object.keys(labels).length}
    //                 value={prrIndex}
    //                 step={1}
    //                 labels={labels}
    //                 ticks
    //                 centerLabels
    //                 onChange={this.handleSettingUpdate}
    //                 disabled={disabled}
    //                 sliderIdForLabelResize="pinRestrictedSlider"
    //             />
    //             <br />
    //         </Modal.Content>
    //         <Modal.Actions>
    //             <b>Note:</b> If a show&apos;s content rating is unavailable, it will be considered
    //             <Label size="tiny">NR</Label>
    //             (Not Rated).
    //             <Button type="button" onClick={onClose} basic>
    //                 Done
    //             </Button>
    //         </Modal.Actions>
    //     </Modal>
    // );
  }
}

/* eslint-disable react/no-unused-prop-types */

PinRestrictions.defaultProps = {
  open: false,
  filterChangesNeedPIN: false,
  // modalMode: false,
  // onUpdate: () => {},
  disabled: false
};